// The app already loads every live listing into ShopContext.all_product. Cards that only know a listing's id
// (e.g. "Recently viewed") use this to get the full, fresh listing: category, condition, seller, current price…
const index = new WeakMap();                      // one id → listing map per loaded array, built once
export function findListing(all, id) {
  if (!Array.isArray(all) || !id) return null;
  let m = index.get(all);
  if (!m) { m = new Map(all.map((p) => [String(p._id), p])); index.set(all, m); }
  return m.get(String(id)) || null;
}
